// extracted by mini-css-extract-plugin
export default {"wrap":"tJ-z","subtitle":"uJ-z","contentWrap":"vJ-z","imgWrap":"wJ-z","heading":"xJ-z","copy":"yJ-z"};